import React from "react";
import { IconProps } from "../icon";

export const Thermometer_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M14.5 4.5a2.5 2.5 0 00-5 0v9.258a4.5 4.5 0 105 0V4.5z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 18.5a1 1 0 100-2 1 1 0 000 2z"
    />
  </svg>
);
